import type React from 'react';
import { useEffect, useState } from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Skeleton } from 'antd';

const exampleOptions = {
  chart: {
    height: 300,
  },
  title: {
    text: 'Combination chart',
  },
  xAxis: {
    categories: ['Apples', 'Oranges', 'Pears', 'Bananas', 'Plums'],
  },
  labels: {
    items: [
      {
        html: 'Total fruit consumption',
        style: {
          left: '50px',
          top: '18px',
          color:
            // theme
            Highcharts.defaultOptions.title?.style?.color || 'black',
        },
      },
    ],
  },
  series: [
    {
      type: 'column',
      name: 'Jane',
      data: [3, 2, 1, 3, 4],
    },
    {
      type: 'column',
      name: 'John',
      data: [2, 3, 5, 7, 6],
    },
    {
      type: 'column',
      name: 'Joe',
      data: [4, 3, 3, 9, 0],
    },
    {
      type: 'spline',
      name: 'Average',
      data: [3, 2.67, 3, 6.33, 3.33],
      marker: {
        lineWidth: 2,
        lineColor: Highcharts.getOptions().colors?.[3],
        fillColor: 'white',
      },
    },
  ],
};

export const ExampleChart: React.VFC = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  });

  return isLoading ? <Skeleton /> : <HighchartsReact highcharts={Highcharts} options={exampleOptions} />;
};
